import { Filter } from "./filter-models";

export class FilterImportResults {
  importFilterError: string | null = null;
  importFilterSuccess: boolean | null = null;
  importFilterMigratedFrom: string | null = null;
  importFilterMigratedTo: string | null = null;
  importFilterExportDate: string | null = null;
  importFilterExportVersion: string | null = null;
  importFilterExportGame: string | null = null;
  importedName: string | null = null;
  filter: Filter | null = null;
}

export class FilterSectionsToUpdate {
  quickFilters = false;
  myWeapons = false;
  myArmour = false;
  myJewellery = false;
  myJewel = false;
  myFlasks = false;
  appendToMyEquipment = false;
  tierCosmetics = true;
  customCosmeticRules = true;
  appendToCustomCosmeticRules = false;
  customRules = false;
  appendToCustomRules = false;
  freeRules = false;
  customCurrencyAndDivCardTiers = false;
  customUniqueTiers = false;
  customChanceBaseTiers = false;
  customGearTiers = false;
  customJewelleryTiers = false;
  customModTiers = false;
  customEquipmentTiers = false;
  identifiedItemConfigs = false;
  tieringModeCustom = false;
  divCardTieringModeCustom = false;
  uniquesTieringModeCustom = false;

  static allRulesOn(): FilterSectionsToUpdate {
    return new FilterSectionsToUpdate({
      quickFilters: true,
      myWeapons: true,
      myArmour: true,
      myJewellery: true,
      myJewel: true,
      myFlasks: true,
      tierCosmetics: true,
      customCosmeticRules: true,
      customRules: true,
      freeRules: true,
      customCurrencyAndDivCardTiers: true,
      customUniqueTiers: true,
      customChanceBaseTiers: true,
      customGearTiers: true,
      customJewelleryTiers: true,
      customModTiers: true,
      customEquipmentTiers: true,
      identifiedItemConfigs: true,
      tieringModeCustom: true,
      divCardTieringModeCustom: true,
      uniquesTieringModeCustom: true,
    });
  }

  static fileImportDefaults(): FilterSectionsToUpdate {
    return new FilterSectionsToUpdate();
  }

  constructor(init?: Partial<FilterSectionsToUpdate>) {
    if (init) Object.assign(this, init);
  }

  setAllRules(enabled: boolean) {
    this.quickFilters = enabled;
    this.myWeapons = enabled;
    this.myArmour = enabled;
    this.myJewellery = enabled;
    this.myJewel = enabled;
    this.myFlasks = enabled;
    this.customRules = enabled;
    this.freeRules = enabled;
    this.customCurrencyAndDivCardTiers = enabled;
    this.customUniqueTiers = enabled;
    this.customChanceBaseTiers = enabled;
    this.customGearTiers = enabled;
    this.customJewelleryTiers = enabled;
    this.customModTiers = enabled;
    this.customEquipmentTiers = enabled;
    this.identifiedItemConfigs = enabled;
    this.tieringModeCustom = enabled;
    this.divCardTieringModeCustom = enabled;
    this.uniquesTieringModeCustom = enabled;
    if (!enabled) {
      this.appendToMyEquipment = false;
      this.appendToCustomRules = false;
    }
  }

  setCosmetics(enabled: boolean) {
    this.tierCosmetics = enabled;
    this.customCosmeticRules = enabled;
    if (!enabled) {
      this.appendToCustomCosmeticRules = false;
    }
  }

  get anyRuleSelected(): boolean {
    return this.quickFilters || this.myWeapons || this.myArmour || this.myJewellery
      || this.myJewel || this.myFlasks || this.customRules || this.freeRules
      || this.customCurrencyAndDivCardTiers || this.customUniqueTiers || this.customChanceBaseTiers
      || this.customGearTiers || this.customJewelleryTiers || this.customModTiers
      || this.customEquipmentTiers || this.identifiedItemConfigs
      || this.tieringModeCustom || this.divCardTieringModeCustom || this.uniquesTieringModeCustom;
  }

  get cosmeticsSelected(): boolean {
    return this.tierCosmetics || this.customCosmeticRules;
  }

  get allSelected(): boolean {
    return this.tierCosmetics && this.customCosmeticRules
      && this.quickFilters && this.myWeapons && this.myArmour && this.myJewellery
      && this.myJewel && this.myFlasks && this.customRules && this.freeRules
      && this.customCurrencyAndDivCardTiers && this.customUniqueTiers && this.customChanceBaseTiers
      && this.customGearTiers && this.customJewelleryTiers && this.customModTiers
      && this.customEquipmentTiers && this.identifiedItemConfigs
      && this.tieringModeCustom && this.divCardTieringModeCustom && this.uniquesTieringModeCustom;
  }
}

export class ImportFilterConfirm {
  sections = new FilterSectionsToUpdate();
  importToNewFilter = false;
  newFilterName = '';
}
